/*
*
* File per JCF 
*
*/

// Imports
//--------------------------------------------------------------------//
import jcf from 'jcf/js/jcf';
import jcfSelect from '../plugins/jcf.select';
import jcfQuerry from 'jcf/js/jquery';


// Init all Select
//--------------------------------------------------------------------//

const jcfUtil = () => {
    jcfQuerry(document).ready(function() {
        jcf.replaceAll();
    });   
}

export default jcfUtil
